import { render } from "./Webloyalty.vue?vue&type=template&id=7aa8869f"
import script from "./Webloyalty.vue?vue&type=script&lang=js"
export * from "./Webloyalty.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__